const { appendFilter } = require('../../../queries');
const addRecipientGroupsQueries = require('../../../queries/configs/RecipientGroups');

module.exports = addRecipientGroupsQueries(function ({ payerId }) {
  return ({
    queriesFilter: appendFilter('payerId', payerId),
  })
});
